module.exports = __webpack_public_path__ + "img/green-ball.19ff3433.webp";